<template>
  <transition name="sidebar" appear>
    <aside class="Sidebar" :class="!PROD && !DEV && '--gray'">
      <header>
        <router-link class="Sidebar__logo-cont" :to="ROUTES.ROOT">
          <img :src="logoSrc" class="Sidebar__logo--new">
        </router-link>
      </header>

      <nav class="Sidebar__nav u-nth-trans-delay t-miniscroll">
        <transition name="sidebar" appear>
          <!-- <ul v-if="hasSelected" class="u-nth-trans-delay"> -->
          <ul class="u-nth-trans-delay">
            <li>
              <router-link :to="ROUTES.ROOT" class="__advers-link"
                           :accesskey="APP_SECTIONS_SHORTS[ROUTES.ROOT] || ''">
                <Icon name="advertisers" />
                Advertisers
              </router-link>
            </li>
            <li v-if="hasSelected"
                v-for="(text, name) in appSections" :key="text">
              <router-link :to="getRoute(name)"
                           :accesskey="APP_SECTIONS_SHORTS[name] || ''"
                           :class="$route.name.startsWith(name) && 'router-link-active'">
                <Icon :name="snakeCase(text)" />
                {{ text }}
              </router-link>
            </li>
          </ul>
        </transition>
        <div class="Sidebar__nav--separator" />
        <ul>
          <li class="--toggle-mini" accesskey="\" @click="$emit('sidebar-toggle')">
            <ArrowFold />
          </li>
<!--           <li v-if="hasSelected">
            <router-link v-if="$root.appId"
                         :to="getRoute(ROUTES.APP_SETTINGS)"
            >
              <Icon name="app_settings" />
              App Settings
            </router-link>
          </li>
 -->          <li v-if="PERMS.MANAGE.VIEW">
            <router-link :to="ROUTES.MANAGE">
              <Icon name="user-edit" />
              Manage Account
            </router-link>
          </li>
        </ul>
      </nav>
    </aside>
  </transition>
</template>
<script>
import ROUTES from 'routes';
import Identity, { permsMixin } from 'store/identity.entity';
import snakeCase from 'lodash/snakeCase';
import logoSrc from 'assets/imgs/sd-logo--new--dark.svg';

export default {
  name: 'Sidebar',
  emits: ['sidebar-toggle'],
  mixins: [permsMixin],

  static: () => ({
    ROUTES,
    logoSrc,
    snakeCase,
    APP_SECTIONS_SHORTS: {
      [ROUTES.ADVER.ROOT]: 'h',
      [ROUTES.ADVER.CAMPAIGNS]: 'c',
      [ROUTES.ADVER.AUDIENCES]: 'd',
      [ROUTES.ADVER.CREATIVES]: 'r',
      [ROUTES.ADVER.INSIGHTS]: 'i',
      [ROUTES.ADVER.APPS]: 'l',
    },
  }),

  methods: {
    getRoute (name) {
      const { adverId } = this.$root;
      return { name, params: { adverId } };
    },
  },

  computed: {
    appSections () {
      return {
        [ROUTES.ADVER.APPS]: 'Apps',
        [ROUTES.ADVER.CAMPAIGNS]: 'Campaigns',
        [ROUTES.ADVER.AUDIENCES]: 'Audiences',
        [ROUTES.ADVER.CREATIVES]: 'Creatives',
        [ROUTES.ADVER.DATA_SOURCES]: 'Data Sources',
        [ROUTES.ADVER.ADS_ACCOUNTS]: 'Ads Accounts',
      };
      // if (Identity.can(PERMS.CONVS.VIEW)) {
      //   sections[ROUTES.CONVERSIONS] = 'Conversions';
      // }
    },

    role () { return Identity.role },
  },

  props: { hasSelected: [Boolean, Object] },
};

</script>

<style lang="postcss">
.Sidebar {
  position: fixed;
  z-index: var(--zi-side, 101);

  display: flex;
  flex-direction: column;
  width: var(--side-w);
  min-height: 100%;

  background: white;
  box-shadow: 0 0 4px #e0e0e0;

  transition: .1s width;
  will-change: width;

  --pad-h: 36px;

  .Icon--apps { transform: scale(.9) }

  &__logo {
    margin-top: 28px;
    width: 104px;
    height: 24px;
    margin-left: 12px;
    fill: white;
  }

  &__logo--new {
    margin-top: 18px;
    height: 42px;
  }

  &__logo-cont {
    position: absolute;
    left: 24px;
    width: 100%;
    overflow: hidden;
    transition: .2s all;
  }

  &__nav {

    display: flex;
    flex-direction: column;
    flex-grow: 10;

    overflow-y: auto;
    /*overflow-x: hidden;*/

    &--separator {
      flex-grow: 2;
      margin-bottom: 28px;
    }

    ul {
      background-color: transparent !important;
      display: block;
      padding-top: 28px;
      padding-bottom: 28px;
    }

    li {
      position: relative;
      height: 48px;
      transition: all .2s ease-out;

      &.__advers-link:not(.router-link-active) {

        &:after {
          position: absolute;
          right: 24px;
          bottom: 0;
          left: 24px;

          border-bottom: 1px solid var(--border-c);

          content: '';
        }
      }

      &:nth-child(4) {
        &:before {
          position: absolute;
          content: '';
          opacity: .12;
          bottom: 0;
          left: 7px;
          right: 7px;
          height: 1px;
          background-color: #f3f3f4;
        }
      }

      &.--toggle-mini {
        cursor: pointer;
        opacity: .3;

        &:hover {
          opacity: .8;
        }

        .ArrowFold {
          border-color: var(--black);
          position: relative;
          top: 16px;
          left: 22px;
          transform: rotate(45deg);
        }
      }

      a {
        position: relative;
        z-index: 10;

        display: inline-block;
        width: var(--side-w);
        height: 48px;
        padding: 16px var(--pad-h);

        color: var(--black);
        line-height: 16px;
        font-size: 13px !important;
        font-weight: 600 !important;

        opacity: .7;

        transition: all .2s;
        will-change: padding, color, background-color;

        i {
          margin-right: 4px;
          vertical-align: top;

          svg {
            transition: .2 all;
            fill: var(--black);
            color: var(--black);
          }
        }

        &:hover, &:focus, &:active, &:visited {
          opacity: 1;
          outline: none;
        }

        &:before {
          z-index: 9;
          content: '';
          width: 6px;
          background-color: transparent;
          position: absolute;
          left: 0; top: 0; bottom: 0;
          transition: all .2s;
          transform: translateX(-6px);
        }

        &.router-link-active{
/*          background-color: #00000044;*/
          opacity: 1;

          &:before {
            transform: translateX(0px);
            background-color: var(--brand);
          }

          &:hover:before {
            background-color: #ff3b3c;
          }
        }
      }
    }

    ul:last-child {
      li:last-child:before {
        height: 1px;
        position: absolute;
        top: 0;
        left: 7px;
        right: 7px;
        z-index: 10;
        font-size: 0;
        /*width: 100%;*/
        content: '';
        opacity: 0.12;
        background-color: var(--bg);
      }
    }
  }

  > header {
    position: relative;
    height: var(--topb-h);

    background-color: var(--white);
    border-bottom: 1px solid var(--black-10);

    &:after {
      content: '';
      font-size: 0;
      height: 1px;
      position: absolute;
      bottom: 0; left: 0; right: 0;
      background-color: white;
      opacity: .12;
    };
  }
}

.sidebar-enter-to, .sidebar-leave {
  transform: translateX(0);
  opacity: 1;

  li {
    transform: translateX(0);
    opacity: 1;
  }

}

.sidebar-enter-active, .sidebar-leave-active {
  transition: all .4s cubic-bezier(.6,1.55,.53,.9);

  li {
    transition-duration: 1s, .1s;
    transition-property: opacity, transform;
    transition-timing-function: ease-in;
  }
}

.sidebar-enter, .sidebar-leave-to {
  background: #ffffff;
  opacity: 0;
  transform: translateX(-220px);

  li {
    opacity: -1;
    transform: translateX(-10px);
  }
}

.t-sidebar-mini {
  --side-w: var(--side-mini-w);

  .Sidebar {
    &__logo-cont {
      left: 12px;
      width: 40px;
    }

    &__logo {
      margin-left: 0;
    }

    &__logo--new {

    }

    &__nav {
      overflow-y: initial;

      li {

        a {
          position: absolute;
          padding: 16px 23px;
          pointer-events: none;
          color: #ffffff00;
          white-space: nowrap;

          i {
            margin-right: 14px;
          }

          &.router-link-active {
            background-color: transparent;
          }

          &:hover {
            width: var(--side-wide-w);
            color: #ffffffff;
            position: absolute;
            background-color: var(--brand);
          }
        }

        &:hover a {
          pointer-events: all;
        }

        &.--toggle-mini .ArrowFold {
          transform: rotate(-135deg);
        }
      }
    }
  }
}

#sd-root .Sidebar.--gray .Sidebar__logo--new {
  filter: grayscale(1) brightness(.5) opacity(0.9);
}

.t-noapp .--toggle-mini {
  opacity: 0 !important;
  pointer-events: none;
}
</style>
